/* Generated automagically by FhirStarter - DO NOT EDIT */
const workflowStepSchema = {
	code: '__string__',
	operator: '__string__',
	studyStatus: '__Reference(StudyStatus)__',
	workflowStepName: '__string__',
};
export default workflowStepSchema;
